/**
 * WebSocket Chatbot Configuration
 */

export const DEFAULT_DEVELOPMENT_CIN = "L24230TG1988PLC009102";

export const getBaseChatWsUrl = () => {
    let url = process.env.REACT_APP_CHAT_WS_URL || "wss://xapi.kohere.in";

    // If running in browser under HTTPS, upgrade ws:// to wss:// for production environments
    if (
        typeof window !== "undefined" &&
        window.location.protocol === "https:" &&
        url.startsWith("ws://") &&
        !url.includes("localhost") &&
        !url.includes("127.0.0.1")
    ) {
        url = url.replace(/^ws:\/\//i, "wss://");
    }

    return url.replace(/\/+$/, "");
};

/**
 * Builds the complete WebSocket endpoint URL with dynamic CIN.
 *
 * @param {string} cin - Company Identification Number
 * @returns {string} Fully qualified WebSocket URL
 */
export const buildChatWebSocketUrl = (cin, token) => {
    const activeCin = (cin || DEFAULT_DEVELOPMENT_CIN).trim();
    const baseUrl = getBaseChatWsUrl();
    let url = `${baseUrl}/api/chat?cin=${encodeURIComponent(activeCin)}`;
    if (token) {
        url += `&token=${encodeURIComponent(token)}`;
    }
    return url;
};

